import { render, staticRenderFns } from "./ElectronicConsentModal.vue?vue&type=template&id=2c554c9f"
import script from "./ElectronicConsentModal.vue?vue&type=script&lang=js"
export * from "./ElectronicConsentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports